<template>
  <PopoverProfileData
    v-tooltip="{ closeOnClick: true }"
    :organization-id="organizationId"
    :membership="membership"
    :profile-fields="fields"
    :column-type="type"
    :show-all-fields-toggle="showAllFieldsToggle"
    title="View details"
    data-tipclass="member-popover-tooltip"
  >
    <MemberProfileData
      :column-type="type"
      :profile-fields="fields"
      :member-data="data"
    />
  </PopoverProfileData>
</template>

<script>
import PopoverProfileData from '~/components/members/PopoverProfileData.vue';
import MemberProfileData from '~/components/members/MemberProfileData.vue';

export default {
  name: 'ReportMemberFields',
  components: {
    PopoverProfileData,
    MemberProfileData,
  },
  props: {
    organizationId: {
      type: [String, Number],
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
      validator: (value) => ['info', 'employment'].includes(value),
    },
    fields: {
      type: Object,
      required: true,
    },
    showAllFieldsToggle: {
      type: Boolean,
      default: true,
    },
    walker: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // FIXME: This is a quick fix to make sure that we can work around the `lazy_members_select`
    // flag on in the T&A and Timesheets approvals reports.
    // Bernat Jufré 2024-03-19
    member() {
      let nameField = null;
      let userId = this.data.main_id;

      switch (this.walker.main_type) {
        case 'team':
          nameField = 'sub';
          break;
        case 'project':
        case 'todo':
          nameField = 'third';
          break;
        case 'date':
        case 'client':
          // Timesheets uses the `sub` field instead.
          if (this.data.fourth) {
            nameField = 'fourth';
          } else {
            nameField = 'sub';
            userId = this.data.sub_id;
          }
          break;

        case 'timesheet':
          nameField = 'user_name';
          break;

        default:
          nameField = 'main';
      }

      return {
        user: {
          id: this.data.user_id || userId,
          name: this.data[nameField],
          avatar_url: this.data.avatar_url,
        },
      };
    },
    membership() {
      const membershipData = { ...this.data, ...this.member };

      membershipData.user.avatar_url ||= this.data.avatar_url;

      return membershipData;
    },
  },
};
</script>
